// deactivate eslint rule so that it doesn't complain from dev dependencies
/* eslint import/no-extraneous-dependencies: 0 */
import { createLogger } from 'redux-logger';

const stringifyFirstDepthCensor = (key: any, value: any) => {
    if (value !== undefined && value !== null && value.type) {
        const { type, ...newValue } = value;
        return newValue;
    }
    if (typeof value === 'function') {
        return 'f(…)';
    }
    if (Array.isArray(value)) {
        return '[…]';
    }
    if (typeof value === 'object') {
        return '{…}';
    }
    return value;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const stringifyFirstDepth = (object: any): string => JSON.stringify(object, stringifyFirstDepthCensor);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createLoggerMiddleware = () => {
    return createLogger({
        diff: true,
        predicate: (getState, action) => {
            return !action.type.startsWith('pendings/');
            // return action;
        },
        collapsed: () => true, // Collapse all logs
        stateTransformer: (state) => state, // return null to hide states
        titleFormatter: (action, date, elapsedTime) =>
            `action ${action.type} @ ${date} / ${elapsedTime} / ${stringifyFirstDepth(action)}`,
    });
};

export default createLoggerMiddleware;
